import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/resources';

interface HeroSectionProps {
  onSearch?: (query: string) => void;
}

export default function HeroSection({ onSearch }: HeroSectionProps) {
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const input = form.querySelector('input') as HTMLInputElement;
    if (onSearch && input.value.trim()) {
      onSearch(input.value.trim());
    }
  };

  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20modern%20creative%20workspace%20with%20warm%20wooden%20desk%2C%20laptop%20displaying%20abstract%20geometric%20patterns%2C%20books%2C%20color%20swatches%2C%20plants%2C%20warm%20golden%20hour%20sunlight%20streaming%20through%20large%20windows%2C%20artistic%20bokeh%20background%20with%20soft%20amber%20and%20cream%20tones%2C%20minimal%20aesthetic%2C%20editorial%20photography%20style%2C%20elegant%20composition%20with%20deep%20depth%20of%20field&width=1800&height=900&seq=hero-2026-main&orientation=landscape"
        alt="给力资源库"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-white mb-4 md:mb-6 leading-tight">
          {siteInfo.name}
        </h1>
        <p className="text-base md:text-xl text-white/85 mb-4 max-w-2xl mx-auto leading-relaxed">
          {siteInfo.tagline}
        </p>
        <p className="text-sm md:text-base text-white/60 mb-8 max-w-xl mx-auto leading-relaxed hidden sm:block">
          {siteInfo.description.slice(0, 100)}...
        </p>

        <form onSubmit={handleSubmit} className="max-w-lg mx-auto flex flex-col sm:flex-row items-stretch gap-3">
          <div className="flex-1 relative">
            <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-foreground-400 text-lg"></i>
            <input
              type="text"
              placeholder="搜索你需要的资源..."
              className="w-full pl-11 pr-4 py-3.5 rounded-xl bg-background-50/95 backdrop-blur-sm text-foreground-800 text-sm outline-none border border-transparent focus:border-primary-400 focus:ring-2 focus:ring-primary-200 transition-all duration-300"
            />
          </div>
          <button
            type="submit"
            className="px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-bold text-sm rounded-xl transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            搜索资源
          </button>
        </form>

        <div className="flex items-center justify-center gap-6 mt-8 flex-wrap">
          <span className="text-white/50 text-xs">热门搜索：</span>
          {['PPT模板', 'UI设计', '考试资料', '视频素材', '源码项目'].map((tag) => (
            <button
              key={tag}
              onClick={() => onSearch?.(tag)}
              className="px-3 py-1.5 rounded-full bg-white/10 hover:bg-white/20 text-white/80 hover:text-white text-xs transition-all duration-300 cursor-pointer whitespace-nowrap backdrop-blur-sm"
            >
              {tag}
            </button>
          ))}
        </div>

        <div className="mt-10 flex items-center justify-center gap-8 md:gap-12 flex-wrap">
          {[
            { value: siteInfo.stats.resources, label: '精品资源' },
            { value: siteInfo.stats.users, label: '活跃用户' },
            { value: siteInfo.stats.downloads, label: '累计下载' },
            { value: siteInfo.stats.updates, label: '更新频率' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-xl md:text-2xl font-black text-white">{stat.value}</div>
              <div className="text-xs text-white/50 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}